module.exports = __webpack_public_path__ + "images/73a2eea7527cbc26f6149a0e9bc10f33-IMG_8212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/IMG_8212.jpg
// module id = ./src/assets/images/slides/home/IMG_8212.jpg
// module chunks = 0